// Copyright (c) 2016 Deere & Company

export default Object.freeze({

    cellClassName: 'grid-cell-style',
    cellLeftClassName: 'grid-cell-style-left-align',
    cellRightClassName: 'grid-cell-style-right-align',
    headerClassName: 'grid-header-style',
    headerLeftClassName: 'grid-header-style-left-align',
    headerRightClassName: 'grid-header-style-right-align',

});
